import React from "react";

import "./style.css";

interface Props {
  children: any;
  justifyContent?: string;
  textAlign?: CanvasTextAlign | undefined;
  height?: string;
  position?: any;
  padding?: string;
  margin?: string;
  width?: string;
  minHeight?: string;
  minWidth?: string;
  flexGrow?: any;
  bg?: string;
  zIndex?: any;
  alignItems?: string;
  flexDirection?:
    | "-moz-initial"
    | "inherit"
    | "initial"
    | "revert"
    | "unset"
    | "column"
    | "column-reverse"
    | "row"
    | "row-reverse"
    | undefined;
}

const Jumbotron: React.FC<Props> = ({
  children,
  flexDirection = "row",
  justifyContent,
  textAlign = "left",
  position,
  height,
  padding="0px",
  bg,
  margin,
  width,
  alignItems,
  zIndex,
  flexGrow="unset",
  minHeight,
  minWidth
}) => {
    let backgroundColor = "transparent"
    if(bg === "green"){
        backgroundColor="green"
    }
    if(bg === "grey"){
      backgroundColor="#eee"
  }
    if(bg === "white"){
        backgroundColor="#fff"
    }
  return (
    <div
      className="container"
      style={{
        flexDirection,
        justifyContent,
        textAlign,
        height,
        position,
        padding,
        backgroundColor,
        margin,
        width,
        flexGrow,
        minHeight,
        minWidth,
        alignItems,
        zIndex
      }}
    >
      {children}
    </div>
  );
};

export default Jumbotron;
